<template>
  <header class="header-title">
    <WParagraph class="header-title__title" variant="heavy">{{
      title
    }}</WParagraph>

    <WButton
      variant="tertiary"
      icon="icClose"
      icon-button
      data-testid="button-close"
      @click="toggleChannelControl"
    />
  </header>
</template>

<script>
import { WButton, WParagraph } from '@alice-health/wonderland-vue'
import { mapState } from 'vuex'

export default {
  components: {
    WButton,
    WParagraph
  },
  computed: {
    ...mapState('ui/channel', ['showHandoff']),
    ...mapState('pillars/channel', ['controlChannel']),
    title() {
      if (this.showHandoff) {
        return 'Plano e comentários'
      }

      if (!this.controlChannel?.id) return 'Criar novo canal'

      return 'Configurações'
    }
  },
  methods: {
    toggleChannelControl() {
      this.$store.commit('pillars/channel/setControlChannel')
      this.$store.commit('pillars/channel/setMergeChannel')
      this.$store.commit('ui/channel/resetChannelsUI')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.header-title {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  min-height: var(--filter-header-height);
  &__title {
    @extend %body-small;
    font-weight: var(--gl-font-weight-medium);
    margin: 0;
  }
}
</style>
